/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/** Tool names that mutate the current bot's editable builder draft. */
export const DRAFT_MUTATION_TOOLS = new Set([
  'create_strategy_draft',
  'update_strategy_draft',
  'normalize_strategy_draft',
  'validate_strategy_draft',
  'publish_strategy_draft',
  'import_bot_version_as_draft',
]);

export const getToolData = (result) => result?.data || result || {};

export const extractDraftMutationPayload = (toolName, result) => {
  if (!DRAFT_MUTATION_TOOLS.has(toolName)) {
    return null;
  }

  const data = getToolData(result);
  const draft = data.draft || (
    data.draft_id || data.id || data.sectioned_spec || data.normalized_spec
      ? data
      : null
  );
  const draftId = draft?.draft_id || draft?.id || data.draft_id || data.id || null;
  const publishedVersionId = (
    draft?.published_version_id ||
    draft?.published_version ||
    data.published_version_id ||
    data.published_version ||
    data.version?.id ||
    data.version_id ||
    null
  );

  if (!draft && !draftId && !publishedVersionId) {
    return null;
  }

  return {
    toolName,
    draft,
    draftId,
    publishedVersionId,
    data,
  };
};
